const paths = {
  Order: '/pedidos',
  Products: '/listar-produtos',
  EditProduct: '/editar-produto',
  NewProduct: '/novo-produto'
}

export default paths
